import React, {memo} from "react";
import Label from "components/general/Label"
import useViewport from "components/general/useViewPort";
import { HorseIcon } from "./TableColumns";
import Competitor from "components/presentation/Competitor";
import Horse from "components/presentation/Horse";
import SportCode from "components/common/SportCode";
import { arraysEqual } from "helpers/utils";

const TableExpanded = memo((props) => {
    const { breakPoint } = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 
    const {row, isStartList} = props;

    const teamPen = row?.extendedResults?.find(er => er?.er_code === 'J_TOTAL_PEN')?.er_value
    const teamTime = row?.extendedResults?.find(er => er?.er_code === 'J_TIME')?.er_value

    const teamAthletes = row?.teamAthletes?.sort((a, b ) => a?.order - b?.order);
    const athrows = teamAthletes?.map(ath => {
        const timePen = ath?.extResults?.find(er => er?.er_code === 'J_T_PEN')?.er_value
        const totalPen = ath?.extResults?.find(er => er?.er_code === 'J_TOTAL_PEN')?.er_value
        const time = ath?.extResults?.find(er => er?.er_code === 'J_TIME')?.er_value
        let jumPen = ath?.extResults?.find(er => er?.er_code === 'J_J_PEN')?.er_value
        const irmCode = ath?.extResults?.find(er => er?.er_code === 'J_IRM')?.er_value
        jumPen = irmCode ?  <SportCode discipline="EQU" entity='@IRM' code={irmCode} abbr={true} /> : jumPen

        const xl = (
            <tr key={ath?.athlete?.code}>
                <td className="text-end"><HorseIcon ath={ath} /></td>
                <td className="text-start"><Competitor hidePicture={true} hideNoc={true} {...ath?.athlete}/></td>
                <td className="text-start"><Horse {...ath?.horse} /></td>
                { !isStartList && <td className="text-end">{jumPen}</td> }
                { !isStartList && <td className="text-end">{timePen}</td> }
                { !isStartList && <td className="text-end">{totalPen}</td> }
                { !isStartList && <td className="text-end">{ath?.order === 2 ? teamPen : ''}</td> }
                { !isStartList && <td className="text-end">{time}</td> }
                { !isStartList && <td className="text-end">{ath?.order === 2 ? teamTime : ''}</td> }                
            </tr>
        );

        const xs = (
            <tr key={ath?.athlete?.code}>
                <td className="text-end"><HorseIcon ath={ath} /></td>
                <td className="text-start">
                    <Competitor hidePicture={true} hideNoc={true} {...ath?.athlete}/>
                    <Horse {...ath?.horse} />
                </td>
                { !isStartList && <td className="text-end">{jumPen}</td> }
                { !isStartList && <td className="text-end">{timePen}</td> }
                { !isStartList && <td className="text-end">{totalPen}</td> }
                { !isStartList && <td className="text-end">{time}</td> }
            </tr>
        );
        
        return isMobile ? xs : xl;

    }); 

    const xl = (
        <table className="w-100 table-borderless">
            <thead>
                <tr>
                    <td className="text-start align-middle w-5" rowSpan={2}></td>
                    <td className="text-start align-middle w-30 fw-bold" rowSpan={2}><Label data="HeaderAthlete" /></td>
                    <td className="text-start align-middle w-30 fw-bold" rowSpan={2}><Label data="HeaderHorse" /></td>
                    { !isStartList && <td className="text-center w-15 fw-bold" colSpan={3}><Label data="HeaderPenalties2" /></td>}
                    { !isStartList && <td className="text-end align-middle w-5 mirs-break-line fw-bold" rowSpan={2}><Label data="HeaderTeamTotal" /></td>}
                    { !isStartList && <td className="text-end align-middle w-10 fw-bold" rowSpan={2}><Label data="HeaderTime" /></td>}
                    { !isStartList && <td className="text-end align-middle w-10 mirs-break-line fw-bold" rowSpan={2}><Label data="HeaderTeamTime" /></td>}
                </tr>
                { !isStartList && 
                    <tr>
                        <td className="text-end w-5 fw-bold"><Label data="HeaderJump" /></td>
                        <td className="text-end w-5 fw-bold"><Label data="HeaderTime" /></td>
                        <td className="text-end w-5 fw-bold"><Label data="HeaderTotal2" /></td>
                    </tr>
                }
            </thead>
            <tbody>
                {athrows}
            </tbody>
        </table>
    );

    const xs = (
        <table className="w-100 table-borderless">
            <thead>
                <tr>
                    <td className="text-start align-middle" rowSpan={2}></td>
                    <td className="text-start align-middle fw-bold" rowSpan={2}><Label data="HeaderAthleteHorse" /></td>
                    { !isStartList && <td className="text-center fw-bold" colSpan={3}><Label data="HeaderPenalties2" /></td>}
                    { !isStartList && <td className="text-end align-middle fw-bold" rowSpan={2}><Label data="HeaderTime" /></td>}
                </tr>
                { !isStartList && 
                    <tr>
                        <td className="text-end fw-bold"><Label data="HeaderJump" /></td>
                        <td className="text-end fw-bold"><Label data="HeaderTime" /></td>
                        <td className="text-end fw-bold"><Label data="HeaderTotal2" /></td>
                    </tr>
                }
            </thead>
            <tbody>
                {athrows}
            </tbody>
        </table>
    );

    return <>{isMobile ? xs : xl}</>

}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    //renderizamos cuando un dato de los visibles cambia
    //return false;
    return arraysEqual(prevProps?.row.teamAthletes, nextProps?.row.teamAthletes);
});


export default TableExpanded;
